import { data } from 'currency-codes'

/** ISO 4217 codes with English names; sorted by code. For VaSelect `text-by` / `value-by`. */
export const iso4217CurrencySelectOptions = [...data]
  .map((c) => ({
    label: `${c.currency} (${c.code})`,
    value: c.code,
  }))
  .sort((a, b) => a.value.localeCompare(b.value))

/** Code-only labels (compact navbar). */
export const iso4217CurrencyCodeOptions = [...data]
  .map((c) => ({
    label: c.code,
    value: c.code,
  }))
  .sort((a, b) => a.value.localeCompare(b.value))
